import React from "react";
import { useApp } from "../../context/AppContext";
import { FONT_SIZES, FONT_FAMILY, ICON_SIZES } from "../../constants/appConfig";

const BUTTON_COLORS = {
  Filters: "#6366f1",
  Portfolios: "#8b5cf6",
  Reports: "#3b82f6",
  Cultivate: "#10b981",
  Settings: "#6b7280",
  Out: "#ef4444",
  Hide: "#6366f1",
};

export const ToolbarButton = ({
  icon: Icon,
  label,
  onClick,
  active = false,
  color,
}) => {
  const { palette, toolbarStyle } = useApp();
  const accentColor = color || palette.accent1;
  const buttonColor = BUTTON_COLORS[label] || accentColor;

  if (toolbarStyle === "solid") {
    return (
      <button
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          padding: "7px 14px",
          borderRadius: 8,
          border: "none",
          background: active ? accentColor : palette.accent1,
          color: "#fff",
          fontSize: FONT_SIZES.xs,
          fontWeight: 700,
          fontFamily: FONT_FAMILY,
          cursor: "pointer",
          transition: "all 0.2s",
          boxShadow: `0 2px 6px ${palette.accent1}30`,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = `0 4px 12px ${palette.accent1}40`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = `0 2px 6px ${palette.accent1}30`;
        }}
      >
        <Icon size={ICON_SIZES.md} />
        {label}
      </button>
    );
  }

  if (toolbarStyle === "pill") {
    return (
      <button
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          padding: "7px 16px",
          borderRadius: 20,
          border: `2px solid ${buttonColor}`,
          background: active ? buttonColor : `${buttonColor}10`,
          color: active ? "#fff" : buttonColor,
          fontSize: FONT_SIZES.xs,
          fontWeight: 700,
          fontFamily: FONT_FAMILY,
          cursor: "pointer",
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = buttonColor;
          e.currentTarget.style.color = "#fff";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = active
            ? buttonColor
            : `${buttonColor}10`;
          e.currentTarget.style.color = active ? "#fff" : buttonColor;
        }}
      >
        <Icon size={ICON_SIZES.md} />
        {label}
      </button>
    );
  }

  // Default: icon-dot (icon-forward with color indicator dots)
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
        padding: "8px 14px",
        borderRadius: 10,
        border: "none",
        background: active ? `${buttonColor}15` : "transparent",
        cursor: "pointer",
        transition: "all 0.2s",
        position: "relative",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = `${buttonColor}12`;
        e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = active
          ? `${buttonColor}15`
          : "transparent";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ position: "relative" }}>
        <Icon
          size={ICON_SIZES.xl}
          style={{ color: active ? buttonColor : palette.text1 }}
        />
        <div
          style={{
            position: "absolute",
            top: -2,
            right: -5,
            width: 9,
            height: 9,
            borderRadius: "50%",
            background: buttonColor,
            border: "2px solid white",
            boxShadow: `0 0 0 1px ${buttonColor}40`,
          }}
        />
      </div>
      <span
        style={{
          fontSize: "0.72rem",
          fontWeight: 600,
          color: active ? buttonColor : palette.text2,
          fontFamily: FONT_FAMILY,
          letterSpacing: "0.3px",
        }}
      >
        {label}
      </span>
    </button>
  );
};
